import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import HomePage from './components/HomePage/HomePage';
import ComingSoonPage from './components/ComingSoonPage/ComingSoonPage';
import ProductsPage from './components/ProductsPage/ProductsPage';
import AartiAppPage from './components/AppPages/AartiAppPage';
import NovelAppPage from './components/AppPages/NovelAppPage';
import MediaPlayerAppPage from './components/AppPages/MediaPlayerAppPage';
import Navigation from './components/Navigation/Navigation';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

function App() {
  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>Nirmal Labs - Daily Useful Apps for Android</title>
          <meta name="description" content="Nirmal Labs develops daily useful Android apps including Aarti, Novel Books, English-Hindi learning, Hindu Calendar, and more. Download from Google Play Store." />
          <meta name="keywords" content="Nirmal Labs, Android apps, Aarti app, Novel books, English Hindi learning, Hindu calendar, Panchang, Indian apps" />
          <meta property="og:title" content="Nirmal Labs - Daily Useful Apps" />
          <meta property="og:description" content="Download useful Android apps by Nirmal Labs including Aarti, Novels, English-Hindi learning apps." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://nirmallabs.com" />
          <meta property="og:image" content="https://nirmallabs.com/images/nirmal-labs-logo.jpg" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Nirmal Labs - Daily Useful Apps" />
          <meta name="twitter:description" content="Download useful Android apps by Nirmal Labs including Aarti, Novels, English-Hindi learning apps." />
          <meta name="twitter:image" content="https://nirmallabs.com/images/nirmal-labs-logo.jpg" />
          <link rel="canonical" href="https://nirmallabs.com" />
          
          {/* Structured Data for Organization */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Nirmal Labs",
              "description": "Nirmal Labs develops daily useful Android apps for users' everyday needs",
              "url": "https://nirmallabs.com",
              "logo": "https://nirmallabs.com/images/nirmal-labs-logo.jpg",
              "sameAs": [
                "https://www.facebook.com/nirmal.labs",
                "https://x.com/LabsNirmal",
                "https://www.linkedin.com/company/nirmallabsvns/",
                "https://www.instagram.com/nirmallabs/"
              ]
            })}
          </script>
        </Helmet>
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/coming-soon" element={<ComingSoonPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/aarti" element={<AartiAppPage />} />
          <Route path="/novel" element={<NovelAppPage />} />
          <Route path="/media-player" element={<MediaPlayerAppPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
